import { GalleryFilterBar } from "@/modules/plus/photos/components/GalleryFilterBar";
import { GalleryGrid } from "@/modules/plus/photos/components/GalleryGrid";

export const GalleryPage: React.FC = () => (
  <main className="mx-auto h-full max-w-7xl overflow-y-auto px-6 py-8">
    <header className="mb-4">
      <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100">Photo gallery</h1>
      <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
        Every user-uploaded accessory photo. Click a tile to edit the caption, re-link to a
        different code, replace the image, or delete it.
      </p>
    </header>
    <GalleryFilterBar />
    <GalleryGrid />
  </main>
);
